<cigna-dcm-advocate-unavailable
  *ngIf="
    !(conversationsFacade.careAdvocateData$ | async)?.agentId &&
      !!(featureTogglesFacade.featuresEnabled(['isDcmChat']) | async);
    else messagingData
  "
  [careAdvocateNotAssignedMessage]="
    (conversationsFacade.careAdvocateData$ | async)?.notAssigned
  "
></cigna-dcm-advocate-unavailable>
<ng-template #messagingData>
  <cigna-omni-messaging-data></cigna-omni-messaging-data>
</ng-template>
